import moment from 'moment'

export const formatDate = UTCDate => {
  return moment.utc(UTCDate).format('MMMM Do YYYY')
}

export const daysAgoForDate = UTCDate => {
  var numberOfDays = moment.utc().diff(moment.utc(UTCDate), 'days')
  return numberOfDays === 0 ? 'Today' : numberOfDays + ' days ago'
}

export const daysAgoAsInt = UTCDate => {
  return moment.utc().diff(moment.utc(UTCDate), 'days')
}

export const timeAgoForManifestFileDate = UTCDate => {
  return moment.utc(UTCDate, 'YYYYMMDDHHmmss').fromNow()
}



// WEBPACK FOOTER //
// ./src/utils/date-utils.js